import { Link } from "react-router-dom";
import errorImg from "../../../assets/images/error-404.svg";
import { hideBar, showBar } from "../../../store/reducers/sidebar";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
const PageNotFound = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(hideBar());

    return () => {
      dispatch(showBar());
    }
  })
  return (
    <div className="error-page container">
      <div className="col-md-8 col-12 offset-md-2">
        <div className="text-center">
          <img
            className="img-error"
            height="435px"
            src={errorImg}
            alt="Not Found"
          />
          <p className="fs-5 text-gray-600">
            Страницата която търсите не е намерена.
          </p>
          <Link to="/" className="btn btn-lg btn-primary mt-3">
            Към начало
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
